import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import './sign.scss';
import Textfield from "../../components/textfield";
import Button, { ButtonRouter } from "../../components/button";
import Container from "../../components/container";
import { validateEmail } from "../../../scripts/helpers/validators";
import useGlobal from "../../../store";
import { MOBILE_VERSION_MAXWIDTH } from "../../../settings/constants";

const In = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;

  const navigate = useNavigate();

  const [ email, setEmail ] = useState ("");
  const [ password, setPassword ] = useState ("");
  const [ error, setError ] = useState ("");

  const isFormValidated = validateEmail( email ) && password !== "";

  function handleSignIn() {

    const isMobile = window?.innerWidth < MOBILE_VERSION_MAXWIDTH;
    const gotoApp = () => navigate( isMobile ? '/deals' : '/' );
    sign.In( email, password, gotoApp, setError );

  }

  useEffect( () => { error !== "" && setError(""); }, [ email, password ] );

  return (

    <Container clear>

      <div className = "sign">

        <div className = "sign__content">

          <div className = "logo" />
          
          <hr />

          <Textfield

            title = "Электронная почта"
            value = { email }
            set = { setEmail }
            placeholder = "Электронная почта"

          />

          <Textfield

            title = "Пароль"
            type = "password"
            value = { password }
            set = { setPassword }
            placeholder = "Введите пароль"

          />

          <hr />

          { error !== "" && <Fragment><p className = "error">{ error }</p><hr /></Fragment> }

          <Button
      
            text = "Войти"
            action = { handleSignIn }
            disabled = { !isFormValidated }

          />

          <p className = "text-center">у меня нет аккаунта</p>

          <ButtonRouter
      
            url = "/signup"
            text = "Зарегистрироваться"

          />
          
        </div>

      </div>

    </Container>

  );

}

export default In;